import { render, staticRenderFns } from "./ParentRow.vue?vue&type=template&id=54bcbf4a&scoped=true&"
import script from "./ParentRow.vue?vue&type=script&lang=js&"
export * from "./ParentRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bcbf4a",
  null
  
)

export default component.exports